/**
 * Alternatives Mapper - Maps API responses to component-friendly data structures
 */

export function mapAlternativesResponse(apiResponse) {
  try {
    if (!apiResponse?.result?.PlanCoverages) {
      console.error("Invalid alternatives API response structure");
      return null;
    }

    // Create a map of ProductId to Rank from Products array
    const rankMap = new Map();
    if (apiResponse.result.Products && Array.isArray(apiResponse.result.Products)) {
      apiResponse.result.Products.forEach((product) => {
        if (product.ProductId && product.Drug?.Rank !== undefined) {
          rankMap.set(product.ProductId, product.Drug.Rank);
        }
      });
    }

    const alternatives = apiResponse.result.PlanCoverages.map((coverage) => {
      // Get rank from Products array using ProductId, fallback to 0
      const rank = rankMap.get(coverage.ProductId) ?? 0;
      
      return {
        productId: coverage.ProductId,
        rank: rank,
        drugName: coverage.Product.name || "Unknown",
        drugDescription: coverage.Product.description || "",
        isGeneric: coverage.Product.is_generic === true,
        drugListTier: coverage.DrugListTier?.name || "N/A",
        formularyTier: coverage.FormularyTier?.name || "N/A",
        umFlags: {
          priorAuthorization: coverage.PriorAuthorization === true,
          stepTherapy: coverage.StepTherapy === true,
          quantityLimit: coverage.QuantityLimit === true,
        },
      };
    });

    // Sort by rank (ascending)
    alternatives.sort((a, b) => a.rank - b.rank);

    return alternatives;
  } catch (error) {
    console.error("Error mapping alternatives response:", error);
    return null;
  }
}

export function mapTherapeuticAlternativesResponse(apiResponse, originalTherapeuticClassId) {
  try {
    if (!apiResponse?.result?.Products) {
      console.error("Invalid therapeutic alternatives API response structure");
      return null;
    }

    console.log('[AlternativesMapper] Original Therapeutic Class ID:', originalTherapeuticClassId, 'Type:', typeof originalTherapeuticClassId);

    const therapeuticAlternatives = apiResponse.result.Products.map((product) => {
      const therapeuticClassId = product.TherapeuticClassId;
      console.log(`[AlternativesMapper] Product: ${product.Drug?.Name}, TherapeuticClassId: ${therapeuticClassId}, Type: ${typeof therapeuticClassId}`);
      
      return {
        productId: product.ProductId,
        drugName: product.Drug?.Name || "Unknown",
        drugDescription: product.Drug?.Description || "",
        therapeuticClass: product.TherapeuticClass || "Unknown",
        therapeuticClassId: therapeuticClassId,
        doseForm: product.Drug?.DoseForm || "",
        strength: product.Drug?.Strength || "",
        unitOfMeasure: product.Drug?.UnitOfMeasure || "",
        isGeneric: product.Drug?.IsGeneric === true,
      };
    });

    // Sort: same class first, then by drug name
    therapeuticAlternatives.sort((a, b) => {
      if (originalTherapeuticClassId) {
        const aSameClass = a.therapeuticClassId === originalTherapeuticClassId;
        const bSameClass = b.therapeuticClassId === originalTherapeuticClassId;
        if (aSameClass !== bSameClass) {
          return aSameClass ? -1 : 1;
        }
      }
      return a.drugName.localeCompare(b.drugName);
    });

    return therapeuticAlternatives;
  } catch (error) {
    console.error("Error mapping therapeutic alternatives response:", error);
    return null;
  }
}
